import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "For this, the right speaker sends an inverted signal (green arrow, 2). This, however, produces a new  unwanted signal at the left ear (orange arrow, 2’).",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/21/principle/principle-3.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
